import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core'
import { EventCardModel } from '@flocasts/experience-service-types'

@Component({
  selector: 'flo-thumbnail-event-card',
  templateUrl: './thumbnail-event-card.component.html',
  styleUrls: ['./thumbnail-event-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThumbnailEventCardComponent implements OnChanges {
  @Input() eventCard: EventCardModel
  @Input() geoBlockedIds: ReadonlyArray<number> = []
  @Output() eventClicked = new EventEmitter<EventCardModel>()
  public isGeoBlocked = false
  public formattedStartDate: string | null = null

  ngOnChanges() {
    this.isGeoBlocked =
      this.eventCard && this.geoBlockedIds ? this.getIsGeoBlocked(this.eventCard, this.geoBlockedIds) : false
    this.formattedStartDate = this.eventCard ? this.getFormattedStartDate(this.eventCard) : null
  }

  private getFormattedStartDate(eventCard: EventCardModel): string | null {
    const startDateTime = eventCard?.label1Parts?.startDateTime
    if (startDateTime && eventCard?.label1Parts?.status !== 'LIVE') {
      const options: Intl.DateTimeFormatOptions = {
        month: 'short',
        year: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: 'short'
      }
      return new Date(startDateTime).toLocaleDateString('en-us', options)
    }
    return null
  }

  private getIsGeoBlocked(eventCard: EventCardModel, geoBlockedIds: ReadonlyArray<number>): boolean {
    const liveEventMetadata = eventCard?.liveEventMetadata
    return (
      !!liveEventMetadata?.liveEventId &&
      liveEventMetadata.checkGeoRestriction &&
      geoBlockedIds.includes(liveEventMetadata.liveEventId)
    )
  }

  handleEventClicked(eventCard: EventCardModel): void {
    // Restrict the users to click on geoblocked cards
    if (!this.isGeoBlocked) this.eventClicked.emit(eventCard)
  }
}
